import React from 'react';
import { FiBookOpen, FiList, FiX } from 'react-icons/fi';
import { getEddyUiCopy } from './eddyBetaUi';

function StudentProfilePanel({ profile, drawer = false, onClose, language = 'en' }) {
  const safeProfile = profile || { alias: '—', scores: [], jupasRanking: [] };
  const initials = String(safeProfile.alias || '—').slice(0, 2).toUpperCase();
  const copy = getEddyUiCopy(language);
  return (
    <aside className={drawer ? 'h-full w-full bg-surface' : 'hidden h-full w-[17rem] shrink-0 border-r border-edge bg-surface/80 xl:block'}>
      <div className="flex h-full flex-col overflow-y-auto px-5 py-6">
        <div className="mb-6 flex items-start justify-between gap-3">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-link">{copy.studentContext}</p>
            <h2 className="mt-1 text-lg font-semibold text-ink">{copy.studentProfile}</h2>
          </div>
          {drawer ? (
            <button type="button" onClick={onClose} className="rounded-full border border-edge p-2 text-ink-muted hover:bg-surface-muted" aria-label="Close profile">
              <FiX aria-hidden />
            </button>
          ) : null}
        </div>

        <div className="rounded-2xl border border-edge bg-surface-muted/70 p-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">{initials}</div>
            <div className="min-w-0">
              <p className="text-[10px] font-semibold uppercase tracking-wider text-ink-subtle">{copy.preferredAlias}</p>
              <p className="truncate text-sm font-semibold text-ink">{safeProfile.alias}</p>
            </div>
          </div>
        </div>

        <section className="mt-6">
          <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-ink"><FiBookOpen className="text-link" aria-hidden /> {copy.selectedSubjects}</div>
          <div className="space-y-2">
            {safeProfile.scores?.map((score) => (
              <div key={score.subject} className="flex items-center justify-between rounded-xl border border-edge bg-surface px-3 py-2.5">
                <span className="text-xs text-ink-muted">{score.subject}</span>
                <span className="rounded-md bg-accent/25 px-2 py-0.5 text-xs font-bold text-link">{score.grade}</span>
              </div>
            ))}
            {!safeProfile.scores?.length ? <p className="rounded-xl border border-edge bg-surface px-3 py-3 text-xs text-ink-subtle">{copy.profileUnavailable}</p> : null}
          </div>
        </section>

        <section className="mt-6">
          <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-ink"><FiList className="text-link" aria-hidden /> {copy.currentRanking}</div>
          <div className="space-y-2">
            {safeProfile.jupasRanking?.map((choice) => <div key={`${choice.band}-${choice.code}`} className="rounded-xl border border-edge bg-surface px-3 py-2.5"><div className="flex items-center justify-between gap-2"><span className="text-xs font-semibold text-link">{choice.band}</span><span className="text-[10px] font-semibold text-ink-subtle">{choice.code}</span></div>{choice.programme ? <p className="mt-1 text-[11px] leading-relaxed text-ink-muted">{choice.programme}</p> : null}</div>)}
            {!safeProfile.jupasRanking?.length ? <p className="rounded-xl border border-edge bg-surface px-3 py-3 text-xs text-ink-subtle">{copy.profileUnavailable}</p> : null}
          </div>
        </section>

        <div className="mt-auto pt-6">
          <div className="rounded-xl border border-edge bg-surface-muted/60 p-3 text-xs leading-relaxed text-ink-subtle">{copy.profileBoundary}</div>
        </div>
      </div>
    </aside>
  );
}

export default StudentProfilePanel;
